module.exports = __webpack_public_path__ + "static/media/mobile eff-1.e5360d71.jpg";